import { ReactNode } from 'react'

interface ButtonProps {
  children?: ReactNode
  className?: string
}

export function Button({ children = 'Download Soonish', className = '' }: ButtonProps) {
  return (
    <a 
      href="https://apps.apple.com/app/6738617431"
      target="_blank"
      rel="noopener noreferrer" 
      className={`bg-primary text-primary-foreground px-8 py-3 rounded-lg font-medium hover:bg-primary/90 transition inline-block ${className}`}
    >
      {children}
    </a>
  )
} 